module.exports = __webpack_public_path__ + "static/img/bg2.f00d8a4.png";